import getHelper from '../../../services/getHelper';
import type { AdministrativeDataFormat } from '../../../../../index';

export default getHelper<AdministrativeDataFormat>('/localization/administrative-data-formats');
